module.exports = __webpack_public_path__ + "static/media/videoimg.46e6313a.png";